import { render, staticRenderFns } from "./TemHead.vue?vue&type=template&id=190e618a&scoped=true&"
import script from "./TemHead.vue?vue&type=script&lang=js&"
export * from "./TemHead.vue?vue&type=script&lang=js&"
import style0 from "./TemHead.vue?vue&type=style&index=0&id=190e618a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190e618a",
  null
  
)

export default component.exports